import { createFileRoute } from "@tanstack/react-router";
import NCFreedomModel from "@/pages/NCFreedomModel";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/nc-freedom-popup-dealer/$slug")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/nc-freedom-popup-dealer/:slug' }),
  component: NCFreedomModel,
});
